import React, { useState, useEffect } from "react";
import { Box, Button, CalendarRange, Modal } from "fds";
import "./index.scss";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import utilsCommon from "../../shared/utils/common";
interface DatePickerModalProps {
  open: boolean;
  date: {
    start: number;
    end: number;
  };
  isClient?: boolean;
  onSubmit: (req: { start: number; end: number }) => void;
  onClose: () => void;
}
const DatePickerModal: React.FC<DatePickerModalProps> = ({
  open,
  date,
  isClient = false,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation();
  const [tempDateRange, changeTempDateRange] = useState<{
    start?: Date;
    end?: Date;
  }>({
    start: undefined,
    end: undefined,
  });
  return (
    <Modal
      title={t("common.period.userRange")}
      open={open}
      onClose={onClose}
      footer={
        <Box classes="filterGroup-user-footer">
          <Button
            btnStyle="fill"
            label={t("common.cancel")}
            type="secondary"
            onClick={onClose}
          />
          <Button
            btnStyle="fill"
            label={t("common.apply")}
            state={
              !tempDateRange.start || !tempDateRange.end ? "disable" : "default"
            }
            onClick={() => {
              onSubmit({
                start: dayjs(tempDateRange.start).valueOf(),
                end: dayjs(tempDateRange.end).valueOf(),
              });
              onClose();
            }}
          />
        </Box>
      }
      width={isClient ? 400 : 540}
      body={
        <Box alignItems="center">
          <CalendarRange
            width={isClient ? 164 : 228}
            startFocusType={""}
            hasLabel
            isClient={isClient}
            allowSameDay
            placeholder={t("common.selectDate")}
            startLabel={t("common.period.from")}
            endLabel={t("common.period.to")}
            startDate={tempDateRange?.start}
            endDate={tempDateRange?.end}
            onSubmit={(date: { start?: Date; end?: Date }) => {
              changeTempDateRange({
                start: date?.start
                  ? utilsCommon.getStartDay(date?.start)
                  : undefined,
                end: date?.end ? utilsCommon.getEndDay(date?.end) : undefined,
              });
            }}
            maxDate={new Date()}
          />
        </Box>
      }
    />
  );
};
export default DatePickerModal;
